export enum LedgerAccount {
  Cash = 1000,
  AssetSuspenseAccount = 1010,
  LiabilitySuspenseAccount = 2010,
  CustomerFunds = 2000,
  TradeReceivables = 1200,
  TradePayables = 2200,
  Revenue = 3000,
  Expenses = 4000,
  ExpensesPaymentFees = 4100,
  RevenueTicket = 3210,
  RevenueTicketFees = 3220,
  RevenuePaymentFees = 3100,
  PaymentPending = 2100,
  InitialMargin = 2210,
  VariationMargin = 2220,
  RevenueTrading = 3200,
}
